import React, { useEffect, useState } from 'react';
import PageLoader from '../UI/loader/PageLoader';
import { ory } from '../providers/authProvider';
import { GenericErrorPage } from '../error/GenericErrorPage';

export const redirectToLogin = async () => {
  const loginFlow = await ory.createBrowserLoginFlow({ refresh: true });
  window.location.replace(loginFlow.data.request_url);
};

export const RedirectToLoginPage = () => {
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    redirectToLogin().catch(() => {
      setIsError(true);
    });
  }, []);

  return isError ? (
    <GenericErrorPage error={new Error('Failed creating browser login flow')} />
  ) : (
    <PageLoader />
  );
};
